import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { SystemUserRole } from './system-user-role.model';

export const SystemUserRoleActions = createActionGroup({
  source: 'SystemUserRole/API', // Namespace for your actions
  events: {
    // Regular actions
    'Load SystemUserRoles': props<{ systemUserRoles: SystemUserRole[] }>(),
    'Add SystemUserRole': props<{ systemUserRole: SystemUserRole }>(),
    'Upsert SystemUserRole': props<{ systemUserRole: SystemUserRole }>(),
    'Add SystemUserRoles': props<{ systemUserRoles: SystemUserRole[] }>(),
    'Upsert SystemUserRoles': props<{ systemUserRoles: SystemUserRole[] }>(),
    'Update SystemUserRole': props<{ systemUserRole: Update<SystemUserRole> }>(),
    'Update SystemUserRoles': props<{ systemUserRoles: Update<SystemUserRole>[] }>(),
    'Delete SystemUserRole': props<{ id: string }>(),
    'Delete SystemUserRoles': props<{ ids: string[] }>(),
    'Clear SystemUserRoles': emptyProps(),

    // Effect actions
    'Get All Roles': props<{ filter: {uniqueId?: string} }>(),
    'Roles Loading State': props<{ loading: boolean }>(),
  }
});
